import { Text } from "@quintype/arrow";
import React, { useState } from "react";
import { get } from "lodash";
import { array, element, string } from "prop-types";
import { connect } from "react-redux";
import ErrorMessage from "../../error-message";
import { LoginPaymentBase } from "../paywall-not-logged-user/login-payment";
import './one-day-paywall.m.css';

const oneDayPaywall = ({ element, text, onedaypaywall, isFree }) => {
  const [isTrue, setIsTrue] = useState(false);
  const onBtnClick = () => setIsTrue(true);
  var starColor = (onedaypaywall.length >= 1 && onedaypaywall[0].data.color !== "#FFFFFF") ? onedaypaywall[0].data.color : "#54C2F0";
  var paywallTitle = onedaypaywall.length >= 2 ? onedaypaywall[1].title : "Haluatko jatkaa lukemista?";
  var paywallText = onedaypaywall.length >= 3 ? onedaypaywall[2].title : "I-P Digi -tilauksella pääset lukemaan tämän ja paljon muita kiinnostavia artikkeleita.";
  var buttonColor = "#54C2F0";
  return (
    <div>
      {!isTrue ? (
        <div styleName="upper-wrapper" className="upper-wrapper">
          <div styleName="upper-para-wrapper" className="upper-para-wrapper">
            <Text element={element} render={text} />
          </div>
          <div styleName="wrapper" className="wrapper">
            <div styleName="line-star-wrapper">
              <div styleName="left-line"></div>
              <div styleName="star" style={{ background: starColor }} className="paywall-not-logged-user">
                <i className="ri-star-fill"></i>
              </div>
              <div styleName="right-line"></div>
            </div>
            <div>
              <h2 styleName="title" className="title">
                {paywallTitle}
              </h2>
            </div>
            <div>
              <p styleName="para" className="para">
                {paywallText}
              </p>
            </div>
            <ErrorMessage />
            <div styleName="buttons">
              {onedaypaywall.length >= 5 ?
                (<a key={onedaypaywall[4].id} styleName="tilaa-btn" style={{ '--tilaa-btn-color': (onedaypaywall[4].data.color !== "#FFFFFF") ? onedaypaywall[4].data.color : buttonColor }} href={onedaypaywall[4].completeUrl}>{onedaypaywall[4].title}</a>)
                : (
                  <a styleName="tilaa-btn-fallback" href="https://asiakaspalvelu.i-mediat.fi/ilkkapohjalainen/tilaa">TILAA</a>
                )
              }

              {(isFree !== false) ?
                (<a onClick={() => onBtnClick()} style={{ '--kirjaudu-btn-color': ((onedaypaywall.length >= 4 && onedaypaywall[3].data.color !== "#FFFFFF") ? onedaypaywall[3].data.color : buttonColor) }} styleName="kirjaudu-btn">
                  KIRJAUDU
                </a>)
                :
                  null
              }
            </div>
            {/* ADDITIONAL LINK BELOW BUTTONS

              (f.ex)
              (kirjaudu) (luo tili)
                     link

            */}
            <div styleName="additional-link">
            {onedaypaywall.length >= 6 &&
                (<a key={onedaypaywall[5].id} style={{ '--additional-link-color': (onedaypaywall[5].data.color != "#ffffff") ? onedaypaywall[5].data.color : '#1297ce' }} href={onedaypaywall[5].completeUrl}>{onedaypaywall[5].title}</a>)
              }

            </div>
          </div>
        </div>
      ) : (
        <div>
          <div styleName="upper-para-wrapper" className="upper-para-wrapper">
            <Text element={element} render={text} />
          </div>
          <LoginPaymentBase />
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    onedaypaywall: get(state, ["qt", "data", "navigationMenu", "onedaypaywall"], [])
  };
}

oneDayPaywall.propTypes = {
  onedaypaywall: array
};

const PaywallOneDay = connect(mapStateToProps, () => ({}))(oneDayPaywall);
export default PaywallOneDay;
